module.exports = __webpack_public_path__ + "pa.0b468e39.svg";